import { Text } from '@chakra-ui/react'

const Label = ({ children }) => (
  <Text textStyle='small' color='black.950'>
    {children}
  </Text>
)

export default Label
